<script setup>
import {computed, onMounted, ref} from "vue";
import store from "@/store";
import {game} from "@/utils/config";
const type = computed(() => {
  let _type = store.state.coupon
  if (_type) {
    const _d = game[_type]
    document.title = _d.title
    return _d
  }
  return {}
})
onMounted(() => {
  store.commit("getCoupon")
});
</script>

<template>
  <component :is="type.coupon+'_store'" />
</template>

<style scoped lang="less">

</style>
